import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import { Catalog } from 'src/types/catalog';
import axiosInstance from 'src/utils/axios';
import { transformCatalogsToTreeData } from 'src/utils/tansformCatalogsToTreeData';

async function fetchCatalogs(): Promise<Catalog[]> {
  const res = await axiosInstance.get<Catalog[]>(api.getCatalogs);
  return res.data;
}

const useGetCatalogsQuery = () => {
  const query = useQuery<Catalog[]>({
    queryKey: [...queryKeys.product.catalogs()],
    queryFn: fetchCatalogs,
  });

  const treeData = useMemo(
    () => (query.data ? transformCatalogsToTreeData(query.data) : undefined),
    [query.data]
  );

  return {
    ...query,
    data: treeData,
    catalogs: query.data,
  };
};

export default useGetCatalogsQuery;
